import { render, staticRenderFns } from "./CreateLead.vue?vue&type=template&id=b6ea7780&"
import script from "./CreateLead.vue?vue&type=script&lang=js&"
export * from "./CreateLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports